

const LogoIcon = () => (
  <svg height="40" viewBox="0 0 100 100">
    <path
      fill="var(--accent-color)"
      d="M50 0 L100 25 L100 75 L50 100 L0 75 L0 25 Z"
    />
    <path
      fill="#FFFFFF"
      d="M50 15 L85 32.5 L85 67.5 L50 85 L15 67.5 L15 32.5 Z"
    />
    <path
      fill="#3A3A3A"
      d="M50 25 L75 37.5 L75 62.5 L50 75 L25 62.5 L25 37.5 Z"
    />
  </svg>
);

export default LogoIcon;